import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

export const zipStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:location.title`,
  additionalCopy: `quote:additionalCopy.location.title`,
  segmentEvent: `Postcode Filled in`,
  fields: [
    {
      type: ServiceRequestFieldType.NUMBER,
      summaryTitle: `quote:location.summaryTitle`,
      props: {
        name: `zip`,
        placeholder: `form:placeholder.postCode`,
        inputProps: {
          maxLength: 5,
        },
        validation: [`isRequired`, `isPostalCode`],
      },
    },
  ],
};
